import React from 'react'
import strings from '../../lang/strings'
import {formatNumber} from '../../helper/common'

export default function ItemNobank(props) {
  const {info} = props
  const day_labels = [strings.request_date, strings.complete_date, strings.refund_date, strings.refund_date]
  const status_labels = [strings.nobank_request, strings.nobank_complete, strings.progressing, strings.refunded]
  return (
    <div className={'point-item-area pv-12'}>
      <div className={'d-flex align-items-center'}>
        <div className='charge_badge f-b fs-14 d-center wx-100'>{info.pay_status == 9 ? strings.pay_cancel : status_labels[info.pay_status]}</div>
        <div className='fs-22 color-0a3962 f-sb ml-20 flex-full'>{formatNumber(info.pay_amount) + strings.won}</div>
        <div className='d-flex align-items-center d-point-item'>
          <div className='fs-12 sm-fs-10 color-9e9e9e'>{info.pay_status == 9 ?  strings.cancel_date: day_labels[info.pay_status]}</div>
          <div className='fs-12 sm-fs-10 f-m color-4c4c4d ml-6'>{info.pay_createdat.dateFormat('YYYY-MM-DD')}</div>
        </div>
      </div>
    </div>
  )
}

